import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const PickUpDropPointsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'PickUpDropPoints' */ './components/PickupDropPoints'
		)
);

export default (store) => {
	return {
		path: 'pickup-drop-points',
		element: <AsyncLoading component={<PickUpDropPointsLazy />} />,
	};
};
